import * as React from 'react';
import { useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';

import NotFoundContainer from '../../containers/NotFoundContainer';
import { GlobalRole, IUser } from '../../models/IUserModel';
import Tracker from '../../utils/Tracker';
import { getCurrentUser, isLoggedIn } from './../../api/authorization';
import Routing from './../../Routing';

interface IProps {
    component: any;
    whitelistRole?: GlobalRole;
}

const AuthRoute: React.FC<IProps> = ({ component: Component, whitelistRole }) => {
    const [working, setWorking] = useState(true);
    const [authenticated, setAuthenticated] = useState(false);
    const [currentUser, setCurrentUser] = useState<IUser | undefined>(undefined);
    const location = useLocation();

    useEffect(() => {
        const authenticate = async () => {
            try {
                const isAuth = await isLoggedIn();

                if (!isAuth) {
                    setWorking(false);
                    setAuthenticated(false);
                    return;
                }

                const user = await getCurrentUser();

                if (isAuth && !user) {
                    setWorking(false);
                    setAuthenticated(false);
                    return;
                }

                if (user && user.globalRole) {
                    Tracker.setRole(user.globalRole);
                }

                setAuthenticated(isAuth);
                setCurrentUser(user);
                setWorking(false);
            } catch (error) {
                console.error('Authentication check failed', error);
                setWorking(false);
                setAuthenticated(false);
            }
        };

        authenticate();
    }, []);

    if (working) {
        return <div />;
    }

    if (!authenticated) {
        return <Navigate to={Routing.AUTH_LOGIN.route} state={{ from: location }} replace />;
    }

    if (whitelistRole && currentUser && whitelistRole !== currentUser.globalRole) {
        return <NotFoundContainer />;
    }

    return <Component user={currentUser} />;
};

export default AuthRoute;
